import { ACCESS_TOKEN } from 'app/constants/LOCALKEYS'
import useSWR from 'swr'
import { useState } from 'react'
import { getPersistData } from './persist'
import { useToken } from './auth/token'
import API from '../../utils/api'

const KEY = '/branch/list'

const fetchKey = (page, pageSize) =>
	`/branch/list?page=${page}&maxData=${pageSize}`;

let swrData: any = getPersistData(KEY)

export function useBranchList(edit, responsibilityId?, teamId?, branchId?, customerName?, address?, depositedAt?, withdrawalAt?, page = 1, pageSize = 10) {
	const { data: token } = useToken();

	const url = fetchKey(page, pageSize);

	const { data, mutate } = useSWR<any>(
		edit ? url : url + '&teamId=' + teamId + '&responsibilityId=' + responsibilityId + '&depositedAt=' + depositedAt + '&branchId=' + branchId + '&address=' + address + '&withdrawalAt=' + withdrawalAt + '&customerName=' + customerName,
		async () => {
			const response = await API.send('GET', edit ? url : url + '&teamId=' + teamId + '&responsibilityId=' + responsibilityId + '&depositedAt=' + depositedAt + '&branchId=' + branchId + '&address=' + address + '&withdrawalAt=' + withdrawalAt + '&customerName=' + customerName, token + '', {})

			return {
				list: response.result?.result.list,
				total: response.result?.result?.totalCount
			};

			// if (res.result.success) {
			// 	swrData = res.result?.result
			// } else {
			// 	swrData = []
			// }
			// return swrData
		},
		{ refreshInterval: 60 * 1000 * 10 }
	)

	return {
		data: data?.list,
		total: data?.total,
		mutate
	}
}
